import React from "react";
import { Lock } from "lucide-react";

const LORA = { fontFamily: "'Lora', Georgia, serif" };

export function LockedDays({ labels, onUnlock }) {
  if (!labels?.length) return null;
  return (
    <div className="relative mt-5" data-testid="locked-days">
      <div className="space-y-4" style={{ filter: "blur(5px)", pointerEvents: "none", userSelect: "none" }} aria-hidden="true">
        {labels.slice(0, 3).map((label, i) => (
          <div key={i} className="card-surface">
            <p className="text-xs uppercase tracking-widest text-[#8B5E34] mb-2" style={LORA}>{label}</p>
            <div className="h-5 bg-[#EDE8E0] rounded w-2/3 mb-3" />
            <div className="h-3 bg-[#EDE8E0] rounded w-full mb-2" />
            <div className="h-3 bg-[#EDE8E0] rounded w-5/6" />
          </div>
        ))}
      </div>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
        <Lock size={22} strokeWidth={1.5} className="text-[#C17F59] mb-3" />
        <p className="text-sm text-[#2B2623] mb-4" style={LORA}>
          {labels.length} jour{labels.length > 1 ? "s" : ""} de plus vous attendent
        </p>
        <button onClick={onUnlock} className="btn-primary text-sm" data-testid="unlock-trip-btn">
          Débloquer tout mon voyage
        </button>
      </div>
    </div>
  );
}
